<template>
	<div>
		<p v-for="(linkData, i) in zulLinkData" :key="i">
			<span v-if="linkData.permitText">{{ linkData.permitText }} </span>
			<a :href="linkData.link" target="_blank">
				<template> {{ linkData.linkText || $t('singleResult.default.linkTemplate') }} </template>
			</a>
		</p>
	</div>
</template>

<script>
import { fieldToLocale } from '@/util/locale';

export default {
	name: 'ZulLinkList',

	props: {
		listId: {
            type: String,
            required: true,
        },
		productData: {
			type: Object,
            required: true,
		}
	},

	computed: {
		zulLinkData() {
			const tab = this.productData.data.listData[this.listId]?.['tab-zul']?.table;
			if (!tab?.length) return [];
			const res = [];
			tab.forEach((row) => {
				if (row['zul-s7']?.textValue) {
					let bvlPermit = this.$store.getters['permit/byId'](row['zul-s7'].selectValue);
					let linkText = bvlPermit?.data.linkText || '';
					let permitText = bvlPermit?.data.permitText || '';
					res.push({
						s7: true,
						link: row['zul-s7'].textValue,
						linkText: linkText ? fieldToLocale(linkText) : '',
						permitText: permitText ? fieldToLocale(permitText) : ''
					})
				} else if (row['zul-s1']?.selectValue) {
					let bvlPermit = this.$store.getters['permit/byId'](row['zul-s1'].selectValue);
					let bvlId = row['zul-s2']?.textValue;
					let tpl = bvlPermit?.data.linkTemplate;
					let linkText = bvlPermit?.data.linkText || '';
					let permitText = bvlPermit?.data.permitText || '';
					if (tpl && bvlId) {
						res.push({
							s1: true,
							link: tpl.replace('%s', bvlId),
							linkText: linkText ? fieldToLocale(linkText) : '',
							permitText: permitText ? fieldToLocale(permitText) : ''
						})
					}
				}
			});
			return res;
		},
	},

};
</script>
